import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { handleApiCall } from "../apis";
import { endpoint } from "../utils/endpoints";

// Create the context
const DataContext = createContext();

// Create a custom hook to use the DataContext
export const useDataContext = () => useContext(DataContext);

// Provider Component
export const DataProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [role, setRole] = useState("");
  const [adminProfile, setAdminProfile] = useState(null);
  const [profileReady, setProfileReady] = useState(false);

  const updateModules = (newData) => {
    setModules(newData);
  };

  const refreshAdminProfile = useCallback(async () => {
    const token = localStorage.getItem("sessionToken");
    if (!token) {
      setAdminProfile(null);
      setProfileReady(true);
      return;
    }
    setProfileReady(false);
    try {
      const response = await handleApiCall("get", endpoint.getAdminProfile, {});
      if (response?.data?.code === 200) {
        const payload = response.data.data;
        setAdminProfile(payload?.adminDetails ?? null);
        if (payload?.role != null) setRole(payload.role);
      } else {
        setAdminProfile(null);
      }
    } catch (e) {
      console.error("getAdminProfile:", e);
      setAdminProfile(null);
    } finally {
      setProfileReady(true);
    }
  }, []);

  useEffect(() => {
    refreshAdminProfile();
  }, [refreshAdminProfile]);

  const isKeyAccountManager = useMemo(() => {
    const v = adminProfile?.role;
    return v != "Admin" 
  }, [adminProfile]);

  return (
    <DataContext.Provider
      value={{
        modules,
        updateModules,
        role,
        setRole,
        adminProfile,
        setAdminProfile,
        profileReady,
        isKeyAccountManager,
        refreshAdminProfile,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
